export default {
    US_EAST_1: "us-east-1", // Ohio
    AP_SOUTH_EAST_2: "ap-southeast-2", // Sydney
    AP_NORTH_EAST_1: "ap-northeast-1", // Tokyo
    EU_CENTRAL_1: "eu-central-1", // Frankfurt
    EU_WEST_1: "eu-west-1", // Ireland
};
